import React from 'react';

export const POSITIONS = {
  cheaper: { label: 'Moins cher que les concurrents', short: 'Moins cher', dot: 'bg-green-500', cls: 'bg-green-50 text-green-700 border-green-200' },
  similar: { label: 'Prix similaire', short: 'Similaire', dot: 'bg-orange-400', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  more_expensive: { label: 'Plus cher que les concurrents', short: 'Plus cher', dot: 'bg-red-500', cls: 'bg-red-50 text-red-700 border-red-200' },
  not_fetched: { label: 'Prix non récupéré', short: 'Non récupéré', dot: 'bg-gray-400', cls: 'bg-gray-100 text-gray-600 border-gray-200' },
};

const CompetitorPositionBadge = ({ position, short = false, testId }) => {
  const p = POSITIONS[position] || POSITIONS.not_fetched;
  return (
    <span data-testid={testId} data-position={position} className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap ${p.cls}`}>
      <span className={`w-2 h-2 rounded-full ${p.dot}`} /> {short ? p.short : p.label}
    </span>
  );
};

export const fmtEur = (v) => (v == null ? '—' : `${Number(v).toFixed(2)} €`);
export const fmtDelta = (v, pct) => {
  if (v == null) return '—';
  const sign = v > 0 ? '+' : '';
  return `${sign}${Number(v).toFixed(2)} €${pct != null ? ` (${sign}${Number(pct).toFixed(1)} %)` : ''}`;
};
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const hostOf = (url) => { try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; } };

export default CompetitorPositionBadge;
